import React, { useState } from "react";
import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function TestInvoices() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const buttons = [
    {
      title: "Standard Invoice",
      style: "bg-gradient-to-r from-blue-500 to-blue-800",
      onClick: () => handleVerifyInvoice(1),
    },
    {
      title: "Debit Note",
      style: "bg-gradient-to-r from-orange-500 to-orange-800",
      onClick: () => handleVerifyInvoice(2),
    },
    {
      title: "Credit Note",
      style: "bg-gradient-to-r from-red-500 to-red-800",
      onClick: () => handleVerifyInvoice(3),
    },
    {
      title: "Simplified Standard",
      style: "bg-gradient-to-r from-green-500 to-green-800",
      onClick: () => handleVerifyInvoice(4),
    },
    {
      title: "Simplified Debit Note",
      style: "bg-gradient-to-r from-cyan-500 to-cyan-800",
      onClick: () => handleVerifyInvoice(5),
    },
    {
      title: "Simplified Credit Note",
      style: "bg-gradient-to-r from-gray-500 to-gray-800",
      onClick: () => handleVerifyInvoice(6),
    },
  ];

  const handleVerifyInvoice = (id) => {
    setLoading(true);
    axios
      .get(`${apiKey}/api/rms/admin/zatca/test-invoice/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        const invoiceTitle =
          {
            1: "Standard Invoice",
            2: "Debit Note",
            3: "Credit Note",
            4: "Simplified Standard",
            5: "Simplified Debit Note",
            6: "Simplified Credit Note",
          }[id] || "Unknown Invoice";

        setData([
          {
            title: invoiceTitle,
            time: new Date().toLocaleString(),
            http_code: res.data?.http_status,
            clearance: res.data?.zatca_response?.clearanceStatus,
            reporting_status:
              res.data?.zatca_response?.reportingStatus,
          },
          ...data,
        ]);
        toast.success(res.data.message || "Invoice verified successfully");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to verify invoice");
      })
      .finally(() => setLoading(false));
  };
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper("ZATCA Test Invoices")}
          </h1>
        </div>
        <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4">
          {buttons.map((button, index) => (
            <button
              key={index}
              className={`p-4 rounded-md text-white font-semibold w-full relative ${button.style} hover:-translate-y-1 hover:translate-x-1 ease-in-out duration-300 hover:shadow-lg`}
              onClick={button.onClick}
              disabled={loading}
            >
              {loading && (
                <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50 grid items-center justify-center">
                  <img
                    className="w-4 mx-auto"
                    src="https://i.gifer.com/ZKZx.gif"
                    alt=""
                  />
                </span>
              )}
              {button.title}
            </button>
          ))}
        </div>
        <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
        <div className="space-y-3 my-2">
          {data.map((item, idx) => (
            <div key={idx} className="rounded-md border-l-4 border-d-bg p-4">
              <h4 className="font-medium">
                [{item.time}] {item.title}:
              </h4>
              <div className="bg-gray-100 w-full p-2 my-2 rounded-2">
                <p className="font-light">
                  <span className="font-medium">Clearance:</span>{" "}
                  {item.clearance || "Not Available"}
                </p>
                <p className="font-light">
                  <span className="font-medium">Reporting Status:</span>{" "}
                  {item.reporting_status || "Not Available"}
                </p>
                <p className="font-light">
                  <span className="font-medium">HTTP Status:</span>{" "}
                  {item.http_code || "Not Available"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}

export default TestInvoices;
